import React, { Component } from 'react';
import './App.css';
import Room from './Room';

class App extends Component {

  state = {
    rooms: [1, 2, 3, 4]
  };

  render() {
    return (
      <div className="App">
        {this.state.rooms.map((roomId) => {
          return (<Room key={roomId} roomId={roomId} className="Room" />);
        })}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js